/* unplugin-vue-components disabled */import script from "./HomeView.vue?vue&type=script&lang=js&setup=true"
export * from "./HomeView.vue?vue&type=script&lang=js&setup=true"

import "./HomeView.vue?vue&type=style&index=0&id=65dc3308&lang=css"

const __exports__ = script;

export default __exports__